export default __webpack_public_path__ + "static/media/check.575111d7.svg";